export const getServicesList = (list, previoulsyAddedServices) => {
  const dropdownList = [];
  if (list?.length) {
    list.forEach(item => {
      const { serviceKey, serviceNameEn } = item;
      const { priceValue: previouslyAddedServiceValue, discountTypeId } =
        previoulsyAddedServices.find(service => service?.productKey === serviceKey) || {};

      dropdownList.push({
        prevValue: previouslyAddedServiceValue,
        serviceName: serviceNameEn,
        serviceKey,
        servicePrevType: discountTypeId,
      });
    });
  }
  return dropdownList;
};

export const createQueryParam = (key, list) => {
  let query = '';
  list?.forEach(item => {
    if (!query) {
      query = `${key}=${item}`;
    } else {
      query = `${query}&${key}=${item}`;
    }
  });
  return query;
};
